import { useEffect, useRef, useState } from 'react';

import { IMG } from '../../const';
import './notification.scss';

const ModalBody = () => {
  return (
    <div className="notificationModal">
      <div className="notificationModal__body">
        <div className="notificationModal__pending-state">
          <img
            src={`${IMG.QUICK_QUOTE}/email-pending.svg`}
            width="116"
            height="116"
            alt="Sending email"
          />
          <h3>Link has been sent to your email!</h3>
          <p className="clr-gray">Please check your email</p>
        </div>
      </div>
    </div>
  );
};

const NotificationEmail = ({ isOpen, onClose }) => {
  const modalContainerRef = useRef(null);
  const [isValid, setValid] = useState(isOpen);

  useEffect(() => {
    if (isOpen && isValid) {
      setTimeout(() => {
        setValid(false);
      }, 2000);
    }

    if (!isOpen) setValid(false);
  }, [isOpen, isValid]);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (modalContainerRef.current && modalContainerRef.current === e.target) {
        isValid && onClose();
      }
    };

    window.addEventListener('click', onClickOutside);
    return () => {
      window.removeEventListener('click', onClickOutside);
    };
  });

  return (
    <dialog
      className={`notification${isValid ? ' open' : ''}`}
      ref={modalContainerRef}
    >
      {isValid ? <ModalBody /> : null}
    </dialog>
  );
};

export default NotificationEmail;
